import React from 'react';
import { type CardComponentProps } from 'nextstepjs';
import { Button } from '@netfront/ui-library';

import { useSmallScreenNavigationSideMenu } from '../SmallScreenNavigationSideMenu/SmallScreenNavigationSideMenuProvider';
import { showSidebarOnIndexes } from './spotLightSteps';

export const SpotlightCard = ({ arrow, currentStep, nextStep, prevStep, skipTour, step, totalSteps }: CardComponentProps) => {
  const { isSidebarOpen, toggleSidebar } = useSmallScreenNavigationSideMenu();
  function onNextStep() {
    const shouldShowSidebarOnNextStep = showSidebarOnIndexes.includes(currentStep + 1);
    if (shouldShowSidebarOnNextStep && !isSidebarOpen) {
      toggleSidebar(true);
      setTimeout(() => nextStep(), 250);
      return;
    } else {
      toggleSidebar(false);
    }

    nextStep();
  }

  function onPrevStep() {
    const shouldShowSidebarOnPreviousStep = showSidebarOnIndexes.includes(currentStep - 1);
    if (shouldShowSidebarOnPreviousStep && !isSidebarOpen) {
      toggleSidebar(true);
      setTimeout(() => prevStep(), 250);
      return;
    } else {
      toggleSidebar(false);
    }

    prevStep();
  }

  function onSkipTour() {
    if (isSidebarOpen) {
      toggleSidebar(false);
    }

    skipTour?.();
  }

  return (
    <div className="c-spotlight-card">
      <div className="c-spotlight-card__header">
        {step.icon && <div className="c-spotlight-card__icon">{step.icon}</div>}
        <h3 className="c-spotlight-card__title">{step.title}</h3>
      </div>

      <div className="c-spotlight-card__content">{step.content}</div>

      {arrow}

      <div className="c-spotlight-card__footer">
        <div className="c-spotlight-card__step">
          Step {currentStep + 1} of {totalSteps}
        </div>

        <div className="c-spotlight-card__actions">
          {currentStep > 0 && <Button onClick={onPrevStep} text="Previous" variant="primary-inverse" size="small" />}

          <Button onClick={onNextStep} text={currentStep === totalSteps - 1 ? 'Finish' : 'Next'} size="small" />

          {step.showSkip && currentStep !== totalSteps - 1 && (
            <button onClick={onSkipTour} className="c-spotlight-card__skip pointer">
              Skip
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
